<template>
    <h1 class="title">Mon agence</h1>
    <div class="card-top">
        <div class="card blue">
            <div class="split">
                <div class="info">
                    <div class="info-row">
                        <label class="info-label b">Nom:</label>
                        <span class="info-value">{{ agency.name }}</span>
                    </div>
                    <div class="info-row">
                        <label class="info-label b">Téléphone:</label>
                        <span class="info-value">{{ agency.telephone }}</span>
                    </div>
                    <div class="info-row">
                        <label class="info-label b">Adresse:</label>
                        <span class="info-value">{{ agency.address }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="card white pdg-25">
            <div id="map" class="map-container" ref="mapContainer"></div>
        </div>
    </div>
    <div class="title-page">
        <h1 class="title">Mes Collaborateurs</h1>
        <router-link to="/franchise/ajouter-compte" class="button outline normal">Créer un compte</router-link>
    </div>
    <div class="head">
        <div class="status">Status</div>
        <div class="name">Nom</div>
        <div class="address">Email</div>
        <div class="action">&nbsp;</div>
    </div>
    <div class="logement-list">
        <div class="logement-line" v-for="account in accounts" :key="account.id">
            <div class="status">
                <div class="dpe">{{ account.status }}</div>
            </div>
            <div class="name">{{ account.lastname }} {{ account.firstname }}</div>
            <div class="address">{{ account.email }}</div>
            <div v-if="account.ID !== user.ID && user.type === 'franchise'" class="action">
                <i v-if="account.type !== 'franchise'" class="bi" :class="account.status === 'actif' ? 'bi-check-square-fill' : 'bi-check-square'" @click="toggleAccountStatus(account.ID)"></i>
                <i class="bi bi-trash-fill" @click="openPopup(account.ID)"></i>
            </div>
            <div v-else class="action"></div>
        </div>
    </div>
    <ConfirmationPopup :isVisible="showPopup" title="Confirmer la suppression"
        message="Êtes-vous sûr de vouloir supprimer ce compte ?" @confirm="deleteAccount" @cancel="closePopup">
    </ConfirmationPopup>
</template>

<script>
import ConfirmationPopup from "@/components/ConfirmationPopup";


/* global google */
export default {
    name: 'MonAgence',
    props: ['searchQuery', 'user'],
    components: {
        ConfirmationPopup,
    },
    data() {
        return {
            agency: {},
            accounts: [],
            accountToDelete: "",
            showPopup: false,
        };
    },
    mounted() {
        this.fetchAgency();
        this.fetchAgencyAccount();
    },
    methods: {
        async fetchAgency() {
            try {
                const response = await fetch(process.env.VUE_APP_API_URL + "franchise/agency", { method: "GET", credentials: 'include', });
                const data = await response.json();
                if (data.error) {
                    window.location.href = "/login";
                } else {
                    this.agency = data;
                    this.initMap();
                }
            } catch (error) {
                console.log("Une erreur est survenue lors de la requête.");
            }
        },
        async fetchAgencyAccount() {
            try {
                const response = await fetch(process.env.VUE_APP_API_URL + "franchise/agency/account", { method: "GET", credentials: 'include', });
                const data = await response.json();
                if (data.error) {
                    window.location.href = "/login";
                } else {
                    this.accounts = data.sort((a, b) => {
                        if (a.type === "franchise" && b.type !== "franchise") return -1;
                        if (a.type !== "franchise" && b.type === "franchise") return 1;

                        return new Date(a.createdAt) - new Date(b.createdAt);
                    });
                }
            } catch (error) {
                console.log("Une erreur est survenue lors de la requête.");
            }
        },
        async initMap() {
            try {
                const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(this.agency.address)}&key=AIzaSyDPtjQ8RlwmsbbNrYRSJbp7MnQHqhsS254`);
                const data = await response.json();

                if (data.results.length === 0) {
                    console.error("Adresse invalide.");
                    return;
                }

                const location = data.results[0].geometry.location;
                const map = new google.maps.Map(document.getElementById("map"), {
                    zoom: 15,
                    center: location,
                    mapId: "AGENCY_ID",
                });

                new google.maps.marker.AdvancedMarkerElement({
                    position: location,
                    map: map,
                    title: "Agence",
                });

            } catch (error) {
                console.error("Une erreur s'est produite :", error);
            }
        },
        async toggleAccountStatus(accountID) {
            try {
                const body = JSON.stringify({ userID: accountID });
                const response = await fetch(process.env.VUE_APP_API_URL + "franchise/account/disable", { method: "POST", headers: { "Content-Type": "application/json" }, credentials: 'include', body, });
                const data = await response.json();

                if (data.error) return window.location.href = "/login";

                this.fetchAgencyAccount();
            } catch (error) {
                console.log("Une erreur est survenue lors de la requête.");
            }
        },
        async deleteAccount() {
            try {
                const response = await fetch(process.env.VUE_APP_API_URL + "franchise/account/delete/" + this.accountToDelete, { method: "GET", credentials: 'include', });
                const data = await response.json();

                if (data.error) return window.location.href = "/login";

                this.fetchAgencyAccount();
                this.closePopup();
            } catch (error) {
                console.log("Une erreur est survenue lors de la requête.");
            }
        },
        openPopup(accountID) {
            this.accountToDelete = accountID;
            this.showPopup = true;
        },
        closePopup() {
            this.showPopup = false;
        },
    },
};
</script>

<style scoped>
h1 {
    font-size: 36px;
}

.split {
    display: flex;
    gap: 50px;
}

.info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.info-row {
    display: flex;
    justify-content: space-between
}

.info-label {
    flex-basis: 20%;
}

.info-value {
    flex-basis: 70%;
}

.head {
    display: flex;
    margin-bottom: 30px;
}

.head>div {
    padding-left: 25px;
    font-size: 14px;
    font-weight: bold;
    color: #a7a7a7;
}

.head>div:nth-child(-n + 2) {
    position: relative;
}

.head>div:nth-child(-n + 2)::after {
    content: "";
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 25px;
    background-color: #ccc;
}

.head .status {
    width: 100px;
}

.head .name {
    flex: 1;
}

.head .address {
    flex: 1;
}

.head .action {
    width: 125px;
}

.logement-list {
    display: flex;
    flex-direction: column;
    gap: 25px;
}

.logement-line {
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 15px;
    filter: drop-shadow(0 0 5px #d3d3d3);
    height: 60px;
}

.logement-line>div {
    padding: 0 25px;
}

.logement-line>div:nth-child(-n + 2) {
    position: relative;
}

.logement-line>div:nth-child(-n + 2)::after {
    content: "";
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 35px;
    background-color: #ccc;
}


.logement-line .status {
    width: 75px;
}


.logement-line .name {
    flex: 1;
    font-weight: bold;
}

.logement-line .address {
    flex: 1;
    font-weight: bold;
}

.logement-line .action {
    width: 100px;
    display: flex;    
    justify-content: flex-end;
    gap: 25px;
}
</style>
